"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Label_1 = __importDefault(require("../Label"));
const styled_1 = require("./styled");
const List = ({ options, optionsTitle, onSelect, close, }) => (react_1.default.createElement(styled_1.OptionsWrapper, null,
    typeof optionsTitle === 'string' ? (react_1.default.createElement(Label_1.default, { secondary: true }, optionsTitle)) : (optionsTitle),
    options.map((i, idx) => (react_1.default.createElement(styled_1.Option, { key: `${i.value}-${idx}`, onClick: () => {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(i.value);
            close === null || close === void 0 ? void 0 : close();
        } }, i.content(false))))));
exports.default = List;
//# sourceMappingURL=List.js.map